import { render, staticRenderFns } from "./SearchCategories.vue?vue&type=template&id=2f053972&scoped=true"
import script from "./SearchCategories.vue?vue&type=script&lang=ts"
export * from "./SearchCategories.vue?vue&type=script&lang=ts"
import style0 from "./SearchCategories.module.scss?vue&type=style&index=0&id=2f053972&prod&lang=scss&module=styles&scoped=true&external"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2f053972",
  null
  
)

export default component.exports